import { render, staticRenderFns } from "./PasswordResetApp.vue?vue&type=template&id=8b7a0f44&"
import script from "./PasswordResetApp.vue?vue&type=script&lang=js&"
export * from "./PasswordResetApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports